export interface SbbRouteOption {
  value: string;
  label: string;
  stationId: number;
}

export const mapAirlineStationToRouteOption = (station: any): SbbRouteOption | null => {
  if (!station?.name) {
    return null;
  }

  const stationId = Number(station?.station_id);
  if (Number.isNaN(stationId)) {
    return null;
  }

  return {
    value: station.name,
    label: station.name,
    stationId
  };
};
